module.exports = __webpack_public_path__ + "img/suitcase-outline-black.9b7ec9a4.svg";